<template>
  <div>
    <b-form @submit.prevent="onSubmit" method="post">
      <b-input-group>
        <b-input-group-prepend is-text>
          <b-icon icon="person-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input v-model="username" placeholder="Логин" required="required"/>
      </b-input-group>
      <b-input-group class="mt-2">
        <b-input-group-prepend is-text>
          <b-icon icon="lock-fill"></b-icon>
        </b-input-group-prepend>
        <b-form-input v-model="password" placeholder="Пароль" type="password" required="required"/>
      </b-input-group>
      <b-button variant="primary" type="submit" class="mt-3 mx-auto form-control">Вход</b-button>
      <b-alert class="mt-2 small mb-0" variant="danger" :show="errorMessage != null" dismissible
               @dismissed="errorMessage=null">
        {{ errorMessage }}
      </b-alert>
    </b-form>
    <b-modal v-model="needChangePassword" hide-footer hide-header no-close-on-backdrop>
      <password-change :old-password="password" @changed="updatePassword"/>
    </b-modal>
  </div>
</template>

<script>
import PasswordChange from "@/components/PasswordChange";
import {mapActions} from "vuex";

export default {
  name: "login-password-auth",
  components: {
    'password-change': PasswordChange
  },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: null,
      needChangePassword: false
    }
  },
  methods: {
    ...mapActions(["loginByPassword", "changePassword"]),
    onSubmit() {
      this.errorMessage = null;
      this.loginByPassword({
        login: this.username,
        password: this.password
      }).then(response => {
        if (response.data?.changePassword === true) {
          this.needChangePassword = true;
        } else {
          this.$router.push('/import');
        }
      }).catch(err => {
        if (err.response != null) {
          if (err.response.status === 403 || err.response.status === 400) {
            this.errorMessage = 'Введён неверный логин или пароль';
          } else {
            this.errorMessage = `Произошла ошибка при авторизации (код ${err.response.status})`;
          }
        } else {
          this.errorMessage = 'Произошла ошибка при авторизации';
        }
      });
      return false;
    },
    updatePassword(newPassword) {
      this.changePassword({
        login: this.username,
        password: this.password,
        newPassword
      }).then(() => {
        this.loginByPassword({
          login: this.username,
          password: newPassword
        }).then(() => {
          this.$router.push('/import');
        }).catch(() => {
          this.$bvToast.toast('Не удалось авторизоваться после смены пароля', {
            title: 'Ошибка',
            autoHideDelay: 5000,
            appendToast: true
          });
        }).finally(() => {
          this.needChangePassword = false;
        });
      }).catch(() => {
        this.$bvToast.toast('Не удалось сменить пароль', {
          title: 'Ошибка',
          autoHideDelay: 5000,
          appendToast: true
        });
      });
    }
  }
}
</script>
